// Assuming imports are set up correctly
import { createAsyncThunk } from '@reduxjs/toolkit'
import { audioAPI } from '../../services/api'
import { commandParameterm, connectParameterN } from '@dataTypes/index'
import { sendAudioCommandfm, sendAudioCommandkm } from '@utils/nlp.util'
import { logger } from '@utils/safeLogger'

// Async thunk to send audio command

export const sendAudioCommandm = createAsyncThunk(
  'audio/sendAudioCommandm',
  async (body: commandParameterm, { rejectWithValue }) => {
    /*
     Send and receive from voice assistant as either in (free/keyword) mode
     Args:
      body (CommandParameterm): Object with stored dispatch functions
     Returns: 
      Objectt:   Object of key-value pair raw response from voice assistant api
    */
    try {
      if (body.type.current == 'free') {
        return await sendAudioCommandfm(body)
      } else if (body.type.current === 'keywords') {
        return await sendAudioCommandkm(body)
      }

      return // Assuming the response has a data field
    } catch (error) {
      logger.error('Failed to send audio command', error)
      return rejectWithValue('Failed to send audio command')
    }
  },
)

export const sendConnectCommand = createAsyncThunk(
  'audio/sendConnectCommand',
  async (body: connectParameterN, { rejectWithValue }) => {
    /*
     Initialize connection Wvoice assistant api then confirm connection status
     Args:
      body (CommandParameterm): Object with stored dispatch functions
     Returns: 
      Objectt:   Object of key-value pair raw response from voice assistant api
    */
    try {
      const formdata = new FormData()
      formdata.append('isfirst', body.isFirst + '')
      formdata.append('stream', body.stream + '')
      const response = await audioAPI.sendConnectCommand(
        formdata,
        body.session_id.current,
        body.type,
      )
      let { result1 } = response
      result1 = result1.replace('"{', '{').replace('}"', '}')
      const result = JSON.parse(result1)
      if (
        typeof result['result'] === 'string' &&
        result['result'] === 'connected'
      ) {
        return { result: true }
      } else {
        return { result: false }
      } // Assuming the response has a data field
    } catch (error) {
      logger.error('Failed to connect audio command', error)
      return rejectWithValue('Failed to connect')
    }
  },
)
